const state = () => {
  return {
    friendList: [],
    createGroupModelVisible: false
  };
};
const mutations = {
  upadteFriendList(state, friendList) {
    state.friendList = friendList;
  },
  reset(state) {
    Object.assign(state, {
      friendList: [],
      createGroupModelVisible: false
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
